import { PureComponent } from 'react'
import styled from 'glamorous'
import { css } from 'glamor'
import { $ } from 'utils'

const eclipse = css.keyframes({
  '30%': { transform: 'translateX(-100%)' },
  '60%': { transform: 'translateX(100%)' }
})

const Container = styled.div({
  position: 'relative',
  width: '100%',
  height: '100%',
  //backgroundColor: 'var(--white)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
})

const LoaderContainer = styled.div({
  margin: 'auto',
  position: 'relative',
  overflow: 'hidden',
  borderRadius: '50%',
  background: 'var(--lightGrey)',
  boxSizing: 'content-box'
}, ({ size = 80 }) => ({
  padding: Math.ceil(size / 16),
  width: size,
  height: size
}))

const Moon = styled.div({
  background: 'var(--white)',
  width: '100%',
  height: '100%',
  borderRadius: '50%'
})

const Earth = styled.div({
  borderRadius: '50%',
  position: 'absolute',
  zIndex: 1000,
  animation: `${eclipse} 2s infinite`,
  background: 'var(--lightGrey)',
}, ({ size = 80 }) => ({
  top: Math.ceil(size / 16),
  left: Math.ceil(size / 8),
  width: size,
  height: size
}))


class Loader extends PureComponent {

  render() {
    const { size, ...props } = this.props
    return (
      $(Container, { ...props },
        $(LoaderContainer, { size },
          $(Moon),
          $(Earth, { size })
        )
      )
    )
  }
}

export default Loader



// WEBPACK FOOTER //
// ./src/components/Loader.js